module.exports = __webpack_public_path__ + "img/组1068.764ba303.png";